import React, {useContext, useState} from 'react';
import {
    StyledHero,
} from './styled'
import {AppContext} from '../../contexts'
import { colors } from "../../branding";
import { scrollToElement } from '../../utilities/index'


const Hero = (props) => {
    const {updateAppContext} = useContext(AppContext);
    const [showPricing, setShowPricing] = useState(true)
    const {showButtons, children} = props

    const handleContactButtonClick= (contactOption) => {
        document.getElementsByName(contactOption)[0].checked = true;
        document.getElementById("ContactForm").querySelector("h2").innerHTML = "Fill in the form below<br/> to start your free trial"

        scrollToElement('ContactForm', -60)

        if (contactOption === 'arrangeTrial') {
            updateAppContext('isTrial', true)
        }
    }

    const renderTrialButton = () => {
        if (! showButtons) {
            return null
        }

        return (
            <button
                type="button"
                onClick={() => handleContactButtonClick('arrangeTrial')}
            >

                <span>
                    Start 30-day free Trial <br/>
                    Instant Activation <br/>
                    No credit card required
                </span>

                <svg aria-hidden="true" tabIndex="0" width="300" height="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200">
                    <defs>
                        <linearGradient id="instant-trial-button-gradient">
                            <stop offset="0" stopColor={`${colors.blueLight}`}/>
                            <stop offset="1" stopColor={`${colors.blueMidLight}`}/>
                        </linearGradient>
                    </defs>
                    <path className="play-btn__svg" d="M 0 0 H 200 L 300 100 L 200 200 H -200 Z" fill="none" />
                </svg>

            </button>
        )
    }

    const renderContactFormButtons = () => {
        if (! showButtons) {
            return null
        }

        const getPricingButton = () => {
            if (showPricing) {
                return (
                    <button onClick={() => scrollToElement("Pricing")}>PRICING</button>
                )
            }

            return (
                <button onClick={e => handleContactButtonClick("getQuote")}>GET A QUOTE</button>
            )
        }


        return (
            <>
                {getPricingButton()}
                <button onClick={e => handleContactButtonClick("bookDemo")}>BOOK A DEMO</button>
                <button onClick={e => handleContactButtonClick("callMe")}>CALL ME</button>
            </>
        )
    }

    return (
        <StyledHero className={"Hero"}>
            <div className="Hero-content-section">
                <div className="Hero-text">
                    {children}
                </div>
                <div className="Hero-buttons">
                    {renderContactFormButtons()}
                </div>
            </div>
            <div className="Hero-cta-section">
                {renderTrialButton()}
            </div>
        </StyledHero>
    )
}

export default Hero;
